import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

import LiveViewForm from './LiveViewForm';

const styles = theme => ({
  content: {
    // padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    borderTop: theme.palette.component.borderOutline,
  },
});

const LiveViewMain = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      <div className={clsx(classes.content)}>
        <LiveViewForm {...props} />
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(LiveViewMain);
